import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormTabItem,
  FormTabItemTypeEnum,
} from '../../interfaces/inspectation-informations.interface';
import { FormControl } from '@angular/forms';
import { validateTCKN } from '../../../../../../../../shared/services/validators/validateTCKN';

@Component({
  selector: 'app-case-form-questions-inputs',
  templateUrl: './case-form-questions-inputs.component.html',
  styleUrl: './case-form-questions-inputs.component.scss',
})
export class CaseFormQuestionsInputsComponent implements OnInit {
  @Input() item!: FormTabItem;
  @Output() valueChange = new EventEmitter<any>();

  FormTabItemTypeEnum = FormTabItemTypeEnum;
  selectedFiles: File[] = [];
  tcknControl = new FormControl('', [validateTCKN]);
  showDescription: boolean = false;
  ngOnInit(): void {
    this.initDropdownOptions();
    this.initAnswerValue();
    this.handleSpecialTypes();
    this.initTcknControl();
    this.initFileType();
  }

  // 1 Dropdown seçeneklerini ayarlar
  private initDropdownOptions(): void {
    this.item.dropdownOptions = this.item?.typeDataParameter?.parameterData
      ? this.item.typeDataParameter.parameterData.map((item: any) => item?.valueObject?.name?.value) ?? []
      : this.item?.typeData ?? [];
  }

  // answerValue'yu başlatır
  private initAnswerValue(): void {
    this.item.answerValue ??= this.item?.defaultAnswer ?? null;
  }

  // Type özel işlemleri
  private handleSpecialTypes(): void {
    const type = this.item.type;

    if (type === FormTabItemTypeEnum.MULTISELECT) {
      this.item.answerValue = this.parseMultiselect(this.item.answerValue);
    }

    if (type === FormTabItemTypeEnum.DATE) {
      this.item.answerValue = this.parseDate(this.item.answerValue);
    }

    if (type === FormTabItemTypeEnum.CHECKBOX) {
      this.shouldShowDescription();
    }
  }

  // Multiselect value parser
  private parseMultiselect(value: any): any[] {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    return String(value).replaceAll(/[{}"]/g, '').split(',');
  }

  // Date value parser
  private parseDate(value: any): Date | null {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  // TCKN kontrolü başlat
  private initTcknControl(): void {
    if (this.item.type !== FormTabItemTypeEnum.ID_NUMBER) return;

    this.tcknControl.setValue(this.item.answerValue ?? '');
    this.tcknControl.valueChanges.subscribe((value) => {
      this.item.answerValue = value;
      this.onValueChange(value);
    });
  }

  // File type işlemleri
  private initFileType(): void {
    if (this.item.type === FormTabItemTypeEnum.FILE && Array.isArray(this.item.answerValue)) {
      this.selectedFiles = this.item.answerValue;
    }
  }


  onValueChange(newValue: any) {
    this.valueChange.emit(newValue);
  }

  onMultiSelectChange(optionValue: any, event: any) {
    if (!Array.isArray(this.item?.answerValue)) {
      this.item.answerValue = [];
    }

    if (event.target.checked) {
      this.item.answerValue = [...this.item.answerValue, optionValue];
    } else {
      this.item.answerValue = this.item.answerValue.filter(
        (v: any) => v !== optionValue
      );
    }

    this.onValueChange(this.item.answerValue);
  }

  isOptionSelected(optionValue: any): boolean {
    return (
      Array.isArray(this.item.answerValue) &&
      this.item.answerValue.includes(optionValue)
    );
  }

  onFileChange(event: any) {
    const files = Array.from(event.target.files);
    this.selectedFiles = [...this.selectedFiles, ...files as File[]];
    this.item.answerValue = this.selectedFiles;
    this.onValueChange(this.item.answerValue);
  }

  removeFile(fileToRemove: File) {
    this.selectedFiles = this.selectedFiles.filter(
      (file) => file !== fileToRemove
    );
    this.item.answerValue = this.selectedFiles;
    this.onValueChange(this.item.answerValue);
  }

  onRadioChange(selectedValue: any) {
    this.shouldShowDescription();
    this.item.description = '';
    this.onValueChange(this.item.answerValue);
  }

  getOptionLabel(option: string): string {
    return option?.replace('_aciklama', '');
  }

  shouldShowDescription() {
    this.showDescription =
      this.item?.answerValue?.includes('_aciklama');
    return this.showDescription;
  }

  get currentLength(): number {
    return this.item?.description?.length;
  }
}
